import { TellescopeModelFromName } from "@tellescope/tanstack-query";

type PartialMedication = Omit<Partial<TellescopeModelFromName<"enduser_medications">>, "enduserId" | "title"> & {
  title: string;
  enduserId: string;
};

type FlatRecord = Record<string, unknown> | unknown;

type NestedObject = {
  [key: string]: unknown | NestedObject;
};

/**
 * Transform flat CSV data with dot notation into nested objects
 * Converts dot notation columns (e.g., "dispensing.quantity") into nested structures
 */
export const transformMedicationData = (flatData: FlatRecord[], enduserId: string): PartialMedication[] => {
  return flatData.map((row) => {
    const medication: NestedObject = { enduserId };

    if (row === null || typeof row !== "object") {
      return medication as PartialMedication;
    }

    Object.keys(row).forEach((key) => {
      const value = row[key as keyof typeof row];

      if (key.includes(".")) {
        // Handle nested fields (e.g., "dispensing.quantity" -> { dispensing: { quantity: value } })
        const parts = key.split(".");
        let current: NestedObject = medication;

        for (let i = 0; i < parts.length - 1; i++) {
          const part = parts[i];
          if (!part) continue;
          if (!current[part] || typeof current[part] !== "object") {
            current[part] = {};
          }
          current = current[part] as NestedObject;
        }

        const lastPart = parts[parts.length - 1];
        if (lastPart) {
          current[lastPart] = value;
        }
      } else {
        // Flat field
        medication[key] = value;
      }
    });

    return medication as PartialMedication;
  });
};
